export enum OpportunityContractStatusOption {
  APPROVED = '5748a073-75b7-42e1-93dc-2a7aeb33ea78',
  DRAFT = 'cf9d7acb-d0a3-462e-9160-de0cf5660775',
  SENIOR_MANAGER_APPROVAL = '67d5694b-08b1-46b1-930d-157bfe609056',
  TOP_EXECUTIVE_APPROVAL = '00da279f-1bad-4fc6-a13d-283d756c332c',
  DENIED = 'f04984eb-1e8e-468a-8d61-5b22ccfd864e',
}
